import React, { useEffect } from "react";
import ScreenHeading from "../../Utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../Utilities/ScrollService";
import Animations from "../../Utilities/Animations";
import "./Resume.css";

const ResumeSection = (props) => {
  useEffect(() => {
    const subscription = ScrollService.currentScreenFadeIn.subscribe(
      (screen) => {
        if (screen.fadeInScreen !== props.id) return;
        Animations.animations.fadeInScreen(props.id);
      }
    );
    return () => subscription.unsubscribe();
  }, [props.id]);

  const experiences = [
    {
      title: "Développeur Web - Stage",
      company: "Citrus Développement",
      location: "Wimereux",
      period: "2025",
      description: [
        "Création d'un site vitrine",
        "Mise en place des formulaires PHP",
        "Page Admin avec suivi des réservations et messages de contact",
      ],
    },
    {
      title: "Commercial - VRP Multicarte",
      company: "Ranger FR",
      location: "Marcq-en-Barœul",
      period: "2019",
      description: [
        "Prospecter dans le but de vendre un produit",
        "Adapter son discours à la personne en face de soi",
      ],
    },
    {
      title: "Conseiller Clientèle",
      company: "DUACOM",
      location: "Douai",
      period: "2018",
      description: [
        "Prise en charge du client, une personne toutes les 3-4 minutes",
        "Gérer les situations complexes avec les clients",
      ],
    },
  ];

  const education = [
    {
      title: "MS Développeur PHP",
      company: "Greta",
      location: "Lens",
      period: "2025",
    },
    {
      title: "Développeur WEB",
      company: "OpenClassrooms",
      location: "Formation à distance",
      period: "2022",
      description: ["Titre Professionnel RNCP Niveau 5 (Bac+2)"],
    },
    {
      title: "BAC Économique & Social",
      company: "Lycée Ozanam",
      location: "Lille",
      period: "2015",
      description: ["Spécialité Sciences Politiques"],
    },
  ];

  return (
    <div className="resume-container screen-container fade-in" id={props.id || ""}>
      <ScreenHeading title={"Cursus"} subHeading={"Formation & Expérience"} />
      <div className="resume-content">
        <div className="resume-columns">
          <div className="resume-column">
            <h3 className="resume-column-title">Formation</h3>
            <div className="timeline-container">
              {education.map((item, index) => (
                <div className="timeline-item" key={index}>
                  <div className="timeline-dot"></div>
                  <div className="timeline-body">
                    <span className="timeline-period">{item.period}</span>
                    <h4 className="timeline-title">{item.title}</h4>
                    <p className="timeline-company">{item.company} — {item.location}</p>
                    {item.description && (
                      <ul className="timeline-description">
                        {item.description.map((desc, idx) => (
                          <li key={idx}>{desc}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="resume-column">
            <h3 className="resume-column-title">Expérience</h3>
            <div className="timeline-container">
              {experiences.map((item, index) => (
                <div className="timeline-item" key={index}>
                  <div className="timeline-dot"></div>
                  <div className="timeline-body">
                    <span className="timeline-period">{item.period}</span>
                    <h4 className="timeline-title">{item.title}</h4>
                    <p className="timeline-company">{item.company} — {item.location}</p>
                    {item.description && (
                      <ul className="timeline-description">
                        {item.description.map((desc, idx) => (
                          <li key={idx}>{desc}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResumeSection;
